var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"store-status",class:_vm.statusClass},[_c('icon',{staticClass:"store-icon",attrs:{"name":_vm.iconName}}),_vm._v(" "+_vm._s(_vm.statusText)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }